import React, { createContext, useContext, useState, useEffect } from 'react';
import i18n from '../i18n/i18n';

// Create the language context
const LanguageContext = createContext();

// Custom hook to use the language context
export const useLanguage = () => {
  return useContext(LanguageContext);
};

// Language provider component
export const LanguageProvider = ({ children }) => {
  // Get current language from i18n or localStorage, default to Serbian
  const [currentLanguage, setCurrentLanguage] = useState(() => {
    return localStorage.getItem('language') || 'sr';
  });

  // Available languages
  const languages = [
    { code: 'sr', name: 'Serbian' },
    { code: 'en', name: 'English' },
    { code: 'sk', name: 'Slovak' },
    { code: 'de', name: 'German' }
  ];

  // Update localStorage and apply language when currentLanguage changes
  useEffect(() => {
    localStorage.setItem('language', currentLanguage);
    i18n.changeLanguage(currentLanguage);
  }, [currentLanguage]);

  // Change the current language
  const changeLanguage = (langCode) => {
    setCurrentLanguage(langCode);
  };

  // Value to be provided to consuming components
  const value = {
    currentLanguage,
    languages,
    changeLanguage
  };

  return (
    <LanguageContext.Provider value={value}>
      {children}
    </LanguageContext.Provider>
  );
};

export default LanguageContext;
